import { useMutation } from 'react-query'

import { useAPI } from '..'
import { PATH } from '../../constants/global'
import { useEffect, useState } from 'react'
import { getAPIErrorMessage } from '../../utils/functions'
import { APIError } from '../types'

export default function (): UseItemKitAdd {
   const [errorMessage, setErrorMessage] = useState<string | null>(null)
   const request = useAPI()

   const {
      error,
      isSuccess: isAddKitSuccess,
      reset: resetAddSuccess,
      mutate,
      data,
   } = useMutation((obj: {}) => request.post(PATH.ITEMS.ADD_TO_KIT, { ...obj }))

   const addToKit = (obj: {}) => mutate(obj)

   useEffect(() => {
      if (error) {
         setErrorMessage(getAPIErrorMessage(error as APIError))
      }
   }, [error])

   useEffect(() => {
      if (data?.data?.Data?.Failed?.length > 0) {
         setErrorMessage('Error adding the Item to the Kit')
      } else {
         setErrorMessage(null)
      }
   }, [data])

   return {
      error: errorMessage,
      isAddKitSuccess,
      resetAddSuccess,
      addToKit,
   }
}
